<template>
  <div>
    <div class="box">
      <Form :model="InformationFrom" :rules="InformationRules" ref="InformationRefs">
        <Row>
          <Col>
            <FormItem label="严重程度" prop="eventSeverity">
              <Select :disabled="eventInfo.currentLink !== 11  && curRole === '县中心管理人员'" transfer clearable
                      v-model="InformationFrom.eventSeverity"
                      @on-change="getEventLevel">
                <Option v-for="(item,index) in eventSeveritysList" :key="index" :label="item.name"
                        :value="item.id"></Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormItem label="事件等级" prop="eventLevel">
              <Select :disabled="eventInfo.currentLink !== 11&& curRole === '县中心管理人员'" transfer clearable
                      v-model="InformationFrom.eventLevel"
                      placeholder="请选择事件等级">
                <Option v-for="(item,index) in DutyLevelList" :key="index" :value="item.id">{{
                    item.name
                  }}
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div style="text-align: center" v-if="eventInfo.currentLink === 11  && curRole === '县中心管理人员'">
        <Button type="primary" @click="handleSubmit('InformationRefs')">提交
        </Button>
        <Button @click="handleReset('InformationRefs')" style="margin-left: 8px">
          重置
        </Button>
      </div>
      <div style="text-align: center" v-if="eventInfo.currentLink === 11  && curRole === '市中心管理人员'">
        <Button type="primary" @click="handleSubmit('InformationRefs')">提交
        </Button>
        <Button @click="handleReset('InformationRefs')" style="margin-left: 8px">
          重置
        </Button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    eventInfo: {
      type: Object,
      default: () => {
      }
    },
    stepInfo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      curRole: null,
      eventSeveritysList: [],
      DutyLevelList: [],
      InformationFrom: {
        eventLevel: '',
        eventSeverity: ''
      },
      InformationRules: {
        eventLevel: [
          {required: true, message: '请选择事件等级', trigger: 'blur'}
        ],
        eventSeverity: [
          {required: true, message: '请选择严重程度', trigger: 'blur'}
        ]
      }
    }
  },
  mounted() {
    this.getUserData()
    this.InformationFrom.eventSeverity = this.eventInfo.eventSeverity
    this.getEventLevel(this.eventInfo.eventSeverity)
    this.InformationFrom.eventLevel = this.eventInfo.eventLevel
    this.getEventSeveritys()
    console.log(this.eventInfo)
  },
  methods: {
    //严重程度
    getEventSeveritys() {
      this.$http.get('/api/eventSeveritys').then(res => {
        this.eventSeveritysList = res.data.data
      })
    },
    getEventLevel(value) {
      console.log(value)
      let id = value
      if (id) {
        this.$http.get(`/api/getEventLevelList/${id}`).then(res => {
          this.DutyLevelList = res.data
        })
      }
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let params = {
            ...this.InformationFrom,
            currentLink: this.eventInfo.currentLink,
            deptIndexCode: this.eventInfo.deptIndexCode,
            id: this.eventInfo.id
          }
          console.log(params)
          this.$http.put('/api/updateAppMessageReceptions', params).then(res => {
            console.log(res)
            this.$emit('refreshStep')
          })
          this.$Message.success('提交成功!');
        } else {
          this.$Message.error('请填写!');
        }
      })
    }
    ,
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    getUserData() {
      this.$http.get('/api/system/cscpCurrentUserDetails').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.curRole = res.data.roleNames
        }
      })
    },
  }
}
</script>
<style scoped lang="less">
.box {
  width: 60%;
  margin: 0 auto;
}
</style>
